module.exports = __webpack_public_path__ + "static/media/train_1.1ddc1869.png";